// extracted by mini-css-extract-plugin
export var attribution = "_6h-4";
export var authorName = "_6h-5";
export var quote = "_6h-3";
export var testimonial = "_6h-2";
export var trustedBy = "_6h-0";
export var trustedByLabel = "_6h-1";